import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)``;

export const InputWrapper = styled('div')`
  position: relative;
  background: ${(p) => p.theme.palette.common.white};
  display: flex;
  flex-direction: column;
  //align-items: center;
  width: 100%;
  border: 1px solid ${(p) => p.theme.palette.grey[300]};
  border-radius: ${(p) => p.theme.spacing(0.5)};
  padding: ${(p) => p.theme.spacing(0, 1)};
  box-shadow: none;

  &:focus-visible {
    /* border: 1px solid ${(p) => p.theme.palette.primary[500]}; */
  }

  &.focused {
    border: 1px solid ${(p) => p.theme.palette.primary[400]};
  }
  &:hover {
    border: 1px solid ${(p) => p.theme.palette.primary[200]};
  }

  & input {
    background: ${(p) => p.theme.palette.common.white};
    height: 30px;
    box-sizing: border-box;
    padding: 4px 6px;
    /* width: 0; */
    /* min-width: 30px; */
    flex-grow: 1;
    border: 0;
    margin: 0;
    outline: 0;
  }
`;

export const SearchInput = styled('input')``;
